import { render, staticRenderFns } from "./PortfolioDetailCard.vue?vue&type=template&id=1cf70c85&"
import script from "./PortfolioDetailCard.vue?vue&type=script&lang=js&"
export * from "./PortfolioDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioDetailCard.vue?vue&type=style&index=0&id=1cf70c85&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports